import Button from 'components/lib/Button'
import useConversationHistoryToggle from 'hooks/useConversationHistoryToggle'
import { sendMessage } from 'modules/conversations/actions'
import { createMessage } from 'modules/message/creators'
import { getInstanceId } from 'modules/session/selectors'
import React, { useLayoutEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { pause } from 'utils'

import './style.css'

const AgentRequestedOptions = ({ message }) => {
  const {
    attributes,
    id,
    conversationId
  } = message
  const dispatch = useDispatch()
  const { endUser } = useSelector(state => state.session)
  const { conversationHistoryOpen } = useConversationHistoryToggle()
  const { chatOpen } = useSelector(state => state.view)
  const [showButtons,setShowButtons] = useState(!chatOpen)
  const instanceId = useSelector(getInstanceId)

  const doSendMessage = ({ label }: { label: string, value: string }) => () => {
    const messageToSend = createMessage({
      message: label,
      activeConversation: conversationId,
      authorId: endUser.id,
      attributes: {
        buttonClicked: true,
        questionId: message.attributes.questionId,
        instanceId
      }
    })
    dispatch(sendMessage({ message: messageToSend }))
  }

  useLayoutEffect(()=> {
    async function delayButtons() {
      if (chatOpen && !showButtons){
        await pause(500)
        setShowButtons(true)
      }
    }

    delayButtons()
  },[showButtons, chatOpen])
  const buttonVisibilityClass = showButtons ? "visible" : "hidden"
  return (
    <ul className={`drift-widget-message-group drift-widget-message-group-type--END_USER drift-bot-buttons--set drift-bot-buttons--${buttonVisibilityClass}`}>
      { attributes.buttons.map((button, index) => (
          <li className="drift-widget-button--list-item"
            aria-posinset={(index+1)}
            key={`bot-button-${id}-${index}`}>
            <Button
              onClick={doSendMessage(button)}
              invertOnHover={true}
              disabled={conversationHistoryOpen}
              aria-label={`${button.label} - Click to reply with this message`}
            >
              {button.label}
            </Button>
          </li>
        ))
      }
    </ul>
  )
}

export default AgentRequestedOptions
